import React from 'react';
import { Input } from 'reactstrap';
import classNames from 'classnames';

import Icon, { faSort, faSortDown, faSortUp } from '~components/icon';

import { getSortDirection, getSortTitle } from './sorter';
import { Column, Row, SortState } from './types';

interface ComponentProps {
  showSelect: boolean;
  columns: Column[];
  showActions: boolean;
  allowSort: boolean;
  sortState: SortState;
  onSort?: (id: string) => void;
  data: Row[];
  selectedIds: string[];
  handleSelectRow: (selectedIds: string[], isBulkOperation?: boolean) => void;
}

const TableHeader: React.FC<ComponentProps> = ({
  showSelect,
  columns,
  showActions,
  allowSort,
  sortState,
  onSort,
  data,
  selectedIds,
  handleSelectRow,
}) => {
  return (
    <thead>
      <tr>
        {showSelect && (
          <th className={'select-cell'}>
            <Input
              type="checkbox"
              id={'select-all-checkboxes'}
              checked={data.length > 0 && data.every((r: Row) => selectedIds.includes(String(r.id)))}
              onChange={(e) => {
                const allIds = data.map((r: Row) => String(r.id));
                const next = e.target.checked ? allIds : [];
                handleSelectRow && handleSelectRow(next, true);
              }}
              aria-label="Select all rows"
              innerRef={(el: HTMLInputElement) => {
                if (!el) return;
                const all = data.length > 0 && data.every((r) => selectedIds.includes(String(r.id)));
                const some = selectedIds.length > 0 && !all;
                el.indeterminate = some;
              }}
            />
          </th>
        )}
        {columns.map((column) => {
          const { id } = column;
          const columnSortable = allowSort && column.sortable !== false;
          const className = classNames([column.classNames?.header], {
            selectable: columnSortable,
          });

          const sortDirection = getSortDirection(sortState, id);
          const sortTitle = getSortTitle(sortState, id);

          return (
            <th key={id} className={className} style={column.style}>
              <div
                className="cell"
                title={columnSortable ? sortTitle : undefined}
                onClick={columnSortable ? () => onSort?.(id) : undefined}
              >
                {column.header}
                {columnSortable &&
                  {
                    asc: <Icon icon={faSortUp} className="sort-icon" />,
                    desc: <Icon icon={faSortDown} className="sort-icon" />,
                    null: <Icon icon={faSort} className="sort-icon invisible" />,
                  }[sortDirection as string]}
              </div>
            </th>
          );
        })}
        {showActions && <th className="actions-cell" style={{ width: '100px' }}></th>}
      </tr>
    </thead>
  );
};

export default TableHeader;
